// This icon file is generated automatically.
var MaximizeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M562.6 430.17a22.1 22.1 0 000 31.23 22.1 22.1 0 0031.23 0l271.25-271.28v211.55a22.06 22.06 0 1044.14-.02V136.84a22.13 22.13 0 00-22.06-22.07H622.34a22.08 22.08 0 000 44.14H833.9L562.6 430.17zM114.77 887.16a22.15 22.15 0 0022.07 22.06h264.83a22.06 22.06 0 100-44.14H190.12l271.28-271.25a22.1 22.1 0 000-31.25 22.13 22.13 0 00-31.24 0L158.9 833.88V622.32a22.06 22.06 0 10-44.13.01v264.83z" } }] }, "name": "maximize", "theme": "outlined" };
export default MaximizeOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/MaximizeOutlined.js
// module id = 3097
// module chunks = 0